<template>
  <div>
    <el-row class="btn-group">
      <el-button
        class="btn-item"
        type="primary"
        size="medium"
        @click="handleBtn('write')"
        v-auth="'after-sales::in-box::history_bind'"
      >
        {{ $t('after-sales::in-box::history_bind') }}
      </el-button>
      <el-tooltip class="item" effect="dark" placement="top-start">
        <span slot="content">
          {{ $t('after-sales::in-box::history_bind_info') }}
        </span>
        <i class="el-icon-question"></i>
      </el-tooltip>
    </el-row>
    <z-table ref="table" v-loading="orderLoading" :data="orders" :columns="columns" :pagination="false">
      <template #skuIds="{ row }">
        <p v-for="(item, i) in row.skuIds" :key="`${i}-${item}`">{{ item }}</p>
      </template>
      <template #payStatus="{ row }">
        <p>{{ $dataCheck(payStatus[row.payStatus]) }}</p>
      </template>
      <template #fulfillmentStatus="{ row }">
        <p>{{ $dataCheck(fulfillmentStatus[row.fulfillmentStatus]) }}</p>
      </template>
      <template #salesStatus="{ row }">
        <p>{{ $dataCheck(salesStatus[row.salesStatus]) }}</p>
      </template>
      <template #operate="{ row }">
        <el-button v-if="row.salesStatus === 0" @click="handleSaleBack(row)" type="text">申请售后</el-button>
        <el-button @click="showDetail(row)" type="text">{{ $t('after-sales::in-box::history_check') }}</el-button>
      </template>
    </z-table>

    <userModal v-model="userVisable" :drawRow="drawRow" @save="handleUpdate"></userModal>
  </div>
</template>
<script>
import moment from 'moment'
import userModal from '../components/user-modal'
import { ORDER_STATUS, SALES_STATUS, FULFILMENTSTATUS, PAY_TYPE, PAY_STATUS } from '@/config'
import { updateEmailSend, getEmailFromOrder } from '@/server/after-sales.js'
import { getOrderList } from '@/server/order.js'
let num = 0
export default {
  name: 'orderInfo',
  components: {
    userModal,
  },
  props: {
    params: {
      default: () => {},
    },
  },
  data() {
    return {
      userVisable: false,
      orderStatus: ORDER_STATUS,
      salesStatus: SALES_STATUS,
      fulfillmentStatus: FULFILMENTSTATUS,
      payType: PAY_TYPE,
      payStatus: PAY_STATUS,
      drawRow: {
        type: 'write',
        item: {},
      },
      columns: [
        {
          prop: 'orderNo',
          label: this.$t('after-sales::in-box::history_order_num'),
          minWidth: '220',
        },
        {
          prop: 'payStatus',
          label: this.$t('after-sales::in-box::history_payment_status'),
          minWidth: '150',
        },
        {
          prop: 'fulfillmentStatus',
          label: this.$t('after-sales::in-box::history_logistics_status'),
          minWidth: '150',
        },
        {
          prop: 'salesStatus',
          label: this.$t('after-sales::in-box::history_sell_status'),
          width: '150',
        },
        {
          prop: 'email',
          label: this.$t('after-sales::in-box::history_email'),
          width: '200',
          formatter: row => this.$dataCheck(row.email),
        },
        {
          prop: 'country',
          label: this.$t('after-sales::in-box::history_country'),
          width: '150',
          formatter: row => this.$dataCheck(row.country),
        },
        {
          prop: 'skuIds',
          label: this.$t('after-sales::in-box::history_sku'),
          width: '130',
        },
        {
          prop: 'payTotalAmount',
          label: this.$t('after-sales::in-box::history_pay_bill'),
          width: '130',
          formatter: row => this.$dataCheck(row.payTotalAmount),
        },
        {
          prop: 'payTime',
          label: this.$t('after-sales::in-box::history_pay_time'),
          width: '200',
          formatter: row => this.$dataCheck(row.payTime),
        },
        {
          prop: 'operate',
          label: this.$t('after-sales::in-box::history_opt'),
          width: '180',
          fixed: 'right',
        },
      ],
      orders: [],
      emailRegister: '',
      orderLoading: false,
      noMore: false,
    }
  },
  mounted() {
    this.getOrderListItem(this.params.emailId)
  },
  methods: {
    async getOrderListItem(id) {
      this.orderLoading = true
      const res = await getEmailFromOrder({ inboxId: id })
      if (res.data.code === this.$code) {
        this.emailRegister = res.data.data
        const { data } = await getOrderList({ emails: res.data.data })
        if (data.code === this.$code) {
          this.orders = data.data.items
        }
      }
      this.orderLoading = false
    },
    handleUpdate() {
      this.getOrderListItem(this.params.emailId)
    },
    handleBtn(type) {
      this.drawRow.type = type
      this.drawRow.item = {
        inboxId: this.params.emailId,
      }
      this.userVisable = true
    },
    handleSaleBack(row) {
      this.$router.push({ path: '/add-after-order', query: { orderNo: row.orderNo } })
      // const h = this.$createElement
      // const that = this
      // this.$message({
      //   type: 'success',
      //   message: h('p', null, [
      //     h('span', null, '创建售后单成功（售后单号为：'),
      //     h('span', { style: 'color: #0560FD' }, row.orderNO),
      //     h('span', null, '('),
      //     h(
      //       'a',
      //       {
      //         on: {
      //           click: () => that.showDetail(row)
      //         }
      //       },
      //       '点击进入详情'
      //     ),
      //     h('span', null, '))')
      //   ])
      // })
    },
    showDetail(row) {
      this.$router.push({ path: `/orderDetail/${row.orderNo}` })
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-group {
  margin-bottom: 16px;
  .btn-item {
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
